import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// styles
import { styled } from '@mui/material/styles';
// components
import { Box, useMediaQuery, useTheme } from '@mui/material';
import DashboardHeader from './header';
import DashboardFooter from './footer';
import NavbarVertical from './navbar/NavbarVertical';
// hooks
import { useCollapseDrawer, useResponsive } from '../../../shared/hooks';
// config
import { HEADER } from '../../config';

// ----------------------------------------------------------------------

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick',
})(() => ({
  flexGrow: 1,
  paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT,
  width: 'auto',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
}));

// ----------------------------------------------------------------------

export function DashboardLayoutWithoutSideNav() {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMessagesPage = location.pathname.startsWith('/messages');

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <DashboardHeader isCollapse={isCollapse} />
      </Box>

      <Box sx={{ display: 'flex', flexGrow: 1, position: 'relative', zIndex: 1 }}>
        <MainStyle
          sx={{
            flexGrow: 1,
            overflow: 'auto',
            paddingBottom: 5,
          }}
          collapseClick={collapseClick}
        >
          <Outlet />
        </MainStyle>
      </Box>
      {!(isMobile && isMessagesPage) && <DashboardFooter />}
    </Box>
  );
}

// ----------------------------------------------------------------------

export function DashboardLayoutWithSideNav() {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  const [open, setOpen] = React.useState(false);

  const isDesktop = useResponsive('up', 'lg');

  React.useEffect(() => {
    if (isDesktop) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [isDesktop]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <DashboardHeader isCollapse={isCollapse} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flex: 1,
          position: 'relative',
          zIndex: 1,
          flexGrow: 1,
          overflow: 'auto',
        }}
      >
        {isDesktop && <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />}

        <MainStyle
          collapseClick={collapseClick}
          sx={{
            flexGrow: 1,
            paddingBottom: 2,
          }}
        >
          <Outlet />
        </MainStyle>
      </Box>

      <Box
        sx={{
          position: 'relative',
          zIndex: 3,
          mt: 'auto',
        }}
      >
        {/* <DashboardFooter /> */}
      </Box>
    </Box>
  );
}
